import { ReactElement } from 'react';
import { CheckList, CheckListProps } from '../check-list';
import { withNativeProps } from '../utils/native-props';
import './style.less';

export type CollapseProps = Omit<CheckListProps, 'checkedClassPrefix'> & {
  children?: ReactElement;
};

export const Collapse = (props: CollapseProps) => {
  return withNativeProps(
    props,
    <CheckList {...props} className="v-collapse" checkedClassPrefix="v-collapse">
      {props.children}
    </CheckList>,
  );
};
